import { Component, inject, Signal, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { ActivatedRoute } from '@angular/router';
import { ClientsService } from '@api/clients';
import { ConnectionsComponent } from '@app/modules/client-management/components/connections/connections.component';
import { DeviceLicensingComponent } from '@app/modules/client-management/components/device-licensing/device-licensing.component';
import { PhoneNumberComponent } from '@app/modules/client-management/components/phone-number/phone-number.component';
import { RequireTotpComponent } from '@app/modules/client-management/components/require-totp/require-totp.component';
import { SessionTimeoutComponent } from '@app/modules/client-management/components/session-timeout/session-timeout.component';
import { TwoWayCommunicationComponent } from '@app/modules/client-management/components/two-way-communication/two-way-communication';
import { FeatureFlagPipe } from '@core';
import { ChildClient, UserRolesIds } from '@models';
import { Store } from '@ngrx/store';
import { AuthSelectors, ClientManagementActions } from '@ngrx-store';
import { InlineInputComponent, PageHeaderComponent } from '@ui';

enum SettingsTab {
  BasicInfo = 'basic-info',
  Connections = 'connections',
}

@Component({
  imports: [MatCardModule, FormsModule, PageHeaderComponent, InlineInputComponent, PhoneNumberComponent, TwoWayCommunicationComponent, SessionTimeoutComponent, RequireTotpComponent, FeatureFlagPipe, ConnectionsComponent, RequireTotpComponent, DeviceLicensingComponent],
  selector: 'avs-settings',
  templateUrl: './settings.component.html',
})
export class SettingsComponent {
  protected client = signal<ChildClient | undefined>(undefined);
  protected eUserRolesIds = UserRolesIds;
  protected readonly eSettingsTab = SettingsTab;
  protected readonly selectedTab = signal<SettingsTab>(
    inject(ActivatedRoute).snapshot.queryParamMap.get('tab') === SettingsTab.Connections
      ? SettingsTab.Connections
      : SettingsTab.BasicInfo,
  );
  protected userRole: Signal<UserRolesIds>;

  private readonly clientsService = inject(ClientsService);
  private readonly childClientId = inject(ActivatedRoute).snapshot.params['clientId'];
  private store = inject(Store);

  constructor() {
    this.userRole = this.store.selectSignal(AuthSelectors.userRole);
    this.clientsService
      .findOne<ChildClient>({ clientId: this.childClientId })
      .subscribe(client => this.client.set(client));
  }

  protected updateClientData(fieldData: Record<string, string>, client: ChildClient) {
    this.store.dispatch(ClientManagementActions.updateChildClient({ clientClientId: client.id, clientData: fieldData }));
  }

  protected selectTab(tab: SettingsTab) {
    this.selectedTab.set(tab);
  }
}
